/**
 * Charge dynamiquement un fichier SCSS du dossier `styles/custom/`
 * @param {string} fileName - config.htmlCustomCSS
 */
export function loadCustomStyles(fileName) {
  if (!fileName || typeof fileName !== 'string' || fileName.trim() === '') {
    console.warn('Aucun nom de style personnalisé fourni.');
    return;
  }

  const normalized = fileName.trim();

  // Webpack context : inclut tous les fichiers .scss du dossier `styles/custom/`
  const customStyles = require.context('../styles/custom', false, /\.s?css$/);

  // Optionnel : vérifier que le fichier demandé existe dans la liste
  const availableFiles = customStyles.keys(); // Exemple : ['./customA.scss', './customB.scss']
  const target = `./${normalized}`;

  if (!availableFiles.includes(target)) {
    console.error(`❌ Style personnalisé introuvable : ${target}`);
    return;
  }

  try {
    customStyles(target);
    console.info(`✅ Style personnalisé chargé : ${normalized}`);
  } catch (err) {
    console.error(`Erreur lors du chargement de ${normalized}`, err);
  }
}
